module.exports =
  ENV: 'production'
  baseApiUrl: 'https://api.salony.com'
